export default {
  specification: 'Špecifikácia',
};
